import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=0f409004&scoped=true&"
import script from "./Tip.vue?vue&type=script&lang=ts&"
export * from "./Tip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f409004",
  null
  
)

export default component.exports